import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { connect } from "react-redux";

function NewFeaturePopup(props) {
  const { subdomain } = props
  const [showPopup, setShowPopup] = useState(false);
  let sevenDaysCookie = Cookies.get("sevenDays");
  let examFindingsCookie = Cookies.get("examFindings");

  useEffect(() => {
    if (subdomain !== 'foreyes') {
      // don't show exam finding popUp to foreyes org
      if (!sevenDaysCookie) {
        Cookies.set("sevenDays", "true", { expires: 7 });
        setShowPopup(true);
      }
      else if (!examFindingsCookie) {
        setShowPopup(true);
      }
    }
  }, []);

  const handleClose = () => {
    sevenDaysCookie = Cookies.get("sevenDays");
    if (sevenDaysCookie) {
      setShowPopup(false);
    } else {
      Cookies.set("examFindings", "dismissed", { expires: 90 });
      setShowPopup(false);
    }
  };

  return (
    <>
      {showPopup && (
        <div className="support-pop-up-align pop-up-align bg-white shadow-lg m-4 border-radius-10">
          <div className="bg-primary py-3 top-primary-bar text-right d-flex justify-content-between align-items-center">
            <h6 className="px-5 text-white">🎉 New Feature!</h6>
            <button type="button" className="btn p-0" onClick={handleClose}>
              <i className="las la-times text-white font-size-12 mr-3"></i>
            </button>
          </div>
          <div className="p-5">
            <h6>Exam Autocoding + Associated Plan Is Live!</h6>
            <p className="my-3">
              👉 <a className="btn-link" href="https://www.manula.com/manuals/itrust/itrust-optometry-cloud-ehr/2/en/topic/auto-fill-exam-findings-associated-diagnosis-and-default-plans" target="_blank" rel="noopener noreferrer">Manual topic</a>
            </p>
            <p>
              📺 <a className="btn-link" href="https://www.youtube.com/watch?v=0WcFWuzfSQM" target="_blank" rel="noopener noreferrer">Watch the YouTube demo</a>
            </p>
          </div>
        </div>
      )}
    </>
  );
}

const mapStateToProps = state => {
  const { organisation: { organisation } } = state
  return {
    subdomain: organisation.subdomain
  }
}

export default connect(mapStateToProps)(NewFeaturePopup);